// @ts-check
/**
 * Order status values and labels for the admin dashboard.
 *
 * ORDER_STATUS mirrors /shared/api-constants.js. The admin build cannot import that file (Create React App
 * refuses imports from outside src), so utils/orderStatus.test.js compares this copy to the shared file.
 */

export const ORDER_STATUS = Object.freeze({
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  PROCESSING: 'processing',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  CANCELLED: 'cancelled',
});

/** Display order for the donut legend; any status not listed here is appended after these. */
export const ORDER_STATUS_ORDER = Object.values(ORDER_STATUS);

/** @param {string} status */
export const orderStatusLabel = (status) => status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
